<template>
  <div class="milestoneMaintenance">
    <div style="text-align: right; padding-bottom: 10px">
			<p class="processword" v-if="!canEdit" style="color: #f11b1b;font-size: 16px;padding: 6px 0 0 5px;float: left">Application approval in progress.</p>
      <el-button type="primary" size="small" @click="goFlowQuery" v-if="allData && allData.projectStatus !== 5">Change Progress Query</el-button>
      <el-button type="primary" size="small" :loading="saveLoading" @click="saveBeforeRefreshGant" :disabled="!canEdit" v-if="allData && allData.projectStatus !== 5">Save and Upload Weekly Reports</el-button>
      <el-tooltip class="item" effect="dark" content="After saving, it will be submitted and the change will take effect after approval" placement="top-start">
        <i class="el-icon-question icon-label" style="font-size: 18px" />
      </el-tooltip>
    </div>
    <el-form :model="milestoneForm" ref="milestoneForm" label-width="0">
      <el-table :data="milestoneForm.tableData" border v-loading="tableLoading" class="milestone-table" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
        <el-table-column label=""  width="40" fixed="left">
          <template v-slot="scope" v-if="canEdit">
            <i class="el-icon-circle-plus-outline" style="font-size: 20px; margin-top: 2px;" @click="addRow(scope.$index)" v-if="scope.$index !== milestoneForm.tableData.length - 1"></i>
            <i class="el-icon-remove-outline" style="font-size: 20px;; margin-top: 2px;" @click="beforeDeleteRow(scope.row, scope.$index)" v-if="scope.$index !== milestoneForm.tableData.length - 1 && milestoneForm.tableData.length > 2"></i>
          </template>
        </el-table-column>
        <el-table-column prop="serialNumber" label="No." width="50" align="center">
          <template v-slot="scope">
            <span style="display: block; padding-bottom: 10px;">{{ scope.row.serialNumber === 999 ? '' : scope.$index  + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="predecessorTaskNumber" label="Predecessor Task" width="80">
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.predecessorTaskNumber'">
              <el-input-number
                :precision="0"
                :controls="false"
                v-model="scope.row.predecessorTaskNumber"
                :disabled="scope.$index === milestoneForm.tableData.length - 1 || !canEdit"
                maxlength="255"
                clearable
                :title="scope.row.predecessorTaskNumber"
                placeholder=""
              />
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="criticalMilestone" min-width="150">
          <template slot="header">
            <span class="hasStar">Key Milestone<span>*</span></span>
          </template>
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.criticalMilestone'" :rules="{ required: true, message: 'Please select' }">
              <el-select clearable v-model="scope.row.criticalMilestone" :disabled="scope.$index === milestoneForm.tableData.length - 1 || !canEdit" placeholder="">
                <el-option
                  v-for="item in yesOrNo"
                  :key="item.labelKey"
                  :label="item.labelValue"
                  :value="item.labelKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="missionCritical" min-width="180">
          <template slot="header">
            <span class="hasStar">Key Task<span>*</span></span>
          </template>
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.missionCritical'" :rules="{ required: true, message: 'Please input' }">
              <el-input v-model="scope.row.missionCritical" :disabled="scope.$index === milestoneForm.tableData.length - 1 || !canEdit" :title="scope.row.missionCritical" clearable></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="missionCriticalDesc:" min-width="180">
          <template slot="header">
            <span class="hasStar">Key Task Description<span>*</span></span>
          </template>
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.missionCriticalDesc'" :rules="{ required: true, message: 'Please input' }">
              <el-input v-model="scope.row.missionCriticalDesc" :disabled="scope.$index === milestoneForm.tableData.length - 1 || !canEdit" :title="scope.row.missionCriticalDesc" clearable></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="progressRatio" min-width="190">
          <template slot="header">
            <span class="hasStar">Progress Percentage (%)<span>*</span></span>
          </template>
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.progressRatio'" :rules="{ required: true, message: 'Please input' }">
             <el-input-number clearable :min="0" :max="100" :controls="false" @change="changeProgressRatio" v-model="scope.row.progressRatio" :disabled="scope.$index === milestoneForm.tableData.length - 1 || !canEdit" />
            </el-form-item>
          </template>
        </el-table-column>
         <el-table-column prop="workAttribute" min-width="180" >
          <template slot="header">
            <span class="hasStar">Work Attribute
              <span>*</span>
              <el-tooltip dangerouslyUseHTMLString="true" class="item" effect="dark" placement="top-start">
                <div slot="content">
                  <strong>Mgmt.</strong>: Project management tasks such as project initiation, planning, implementation, monitoring, and acceptance.
                  <br/>
                  <strong>Delivery</strong>: The specific implementation work includes project design, installation, supervision and commissioning.
                </div>
                <i class="el-icon-question icon-label" />
              </el-tooltip>
            </span>
          </template>
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.workAttribute'" :rules="{ required: scope.$index !== milestoneForm.tableData.length-1, message: 'Please select' }">
              <el-select clearable @change="changeLHA" v-model="scope.row.workAttribute" :disabled="scope.$index === milestoneForm.tableData.length - 1 || !canEdit" placeholder="">
                <el-option
                  v-for="item in AttributeList"
                  :key="item.labelKey"
                  :label="item.labelValue"
                  :value="item.labelKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="estimatedWorkload" label="Labor-hour Assessment（Person-day）" min-width="180">
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.estimatedWorkload'">
              <el-input-number clearable :min="0" :precision="2" :controls="false"  @change="changeDays" :disabled="scope.$index === milestoneForm.tableData.length - 1 || !canEdit" v-model="scope.row.estimatedWorkload" />
            </el-form-item>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="riskLevel" label="Risk Level" min-width="180">
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.riskLevel'">
              <el-select clearable v-model="scope.row.riskLevel" :disabled="scope.$index === milestoneForm.tableData.length - 1 || !canEdit" placeholder="">
                <el-option
                  v-for="item in riskLevel"
                  :key="item.labelKey"
                  :label="item.labelValue"
                  :value="item.labelKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column> -->
        <el-table-column prop="status" min-width="180">
          <template slot="header">
            <span class="hasStar">Current Status<span>*</span></span>
          </template>
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.status'" :rules="{ required: true, message: 'Please select' }">
              <el-select clearable v-model="scope.row.status" :disabled="scope.$index === milestoneForm.tableData.length - 1 || !canEdit" placeholder="">
                <el-option
                  v-for="item in milestoneStatus"
                  :key="item.labelKey"
                  :label="item.labelValue"
                  :value="item.labelKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="startTime" min-width="150">
          <template slot="header">
            <span class="hasStar">Start Date<span>*</span></span>
          </template>
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.startTime'" :rules="{ required: true, message: 'Please select' }">
              <el-date-picker
                :disabled="scope.$index === milestoneForm.tableData.length - 1 || !canEdit"
                v-model="scope.row.startTime"
                type="date"
                value-format="yyyy-MM-dd" 
                placeholder=""
                :picker-options="{ disabledDate: disabledStartDate }"
                @change="changStartTime"
              >
              </el-date-picker>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="endTime" min-width="150">
          <template slot="header">
            <span class="hasStar">End Date<span>*</span></span>
          </template>
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.endTime'" :rules="{ required: true, message: 'Please select' }">
              <el-date-picker
                :disabled="scope.$index === milestoneForm.tableData.length - 1 || !canEdit"
                v-model="scope.row.endTime"
                type="date"
                value-format="yyyy-MM-dd" 
                placeholder=""
                :picker-options="{ disabledDate: disabledEndDate }"
                @change="changEndTime"
              >
              </el-date-picker>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="taskLeader" min-width="180">
          <template slot="header">
            <span class="hasStar">Task Owner<span>*</span></span>
          </template>
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.taskLeader'" :rules="{ required: true, message: 'Please select' }">
              <el-select
                v-model="scope.row.taskLeader"
                multiple
                clearable
                filterable
                remote
                placeholder=""
                :filter-method="filterUser"
                disabled
                v-if="scope.$index === milestoneForm.tableData.length - 1"
              >
                <el-option v-for="(item) in leaderLastList" :key="item.empCode" :label="item.userCode" :value="item.empCode"></el-option>
              </el-select>
              <el-select
                v-model="scope.row.taskLeader"
                multiple
                clearable
                filterable
                remote
                placeholder=""
                :filter-method="filterUser"
                :disabled="scope.$index === milestoneForm.tableData.length - 1 || !canEdit"
                v-else
              >
                <!-- <el-option v-for="(item) in leaderList" :key="item.empCode" :label="item.userCode" :value="item.empCode"></el-option> -->
                <el-option v-for="(item) in [...leaderList, ...(scope.$index === milestoneForm.tableData.length - 1 ? leaderLatList : [])]" :key="item.empCode" :label="item.userCode" :value="item.empCode"></el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="sync" label="Upload Weekly Reports" min-width="180">
          <template slot="header">
            <span class="hasStar">Upload Weekly Reports<span>*</span></span>
          </template>
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.sync'" :rules="{ required: true, message: 'Please select' }">
              <el-select clearable v-model="scope.row.sync" :disabled="scope.$index === milestoneForm.tableData.length - 1 || !canEdit" placeholder="">
                <el-option
                  v-for="item in yesOrNo"
                  :key="item.labelKey"
                  :label="item.labelValue"
                  :value="item.labelKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column> -->
        <el-table-column prop="updatedTime" label="Update Date" min-width="180">
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.updatedTime'">
              <el-date-picker
                v-model="scope.row.updatedTime"
                type="date"
                value-format="yyyy-MM-dd" 
                placeholder=""
                disabled
              >
              </el-date-picker>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <div>
      <div id="gantt_here" style="width: 100%; height: 400px;"></div>
		</div>
    <el-dialog
			:title="openReasonInfo.type === 'delete' ? 'Delete' : 'Save and Upload Weekly Reports'"
			width="600px"
			:visible.sync="reasonVisible"
			:close-on-click-modal="false"
      @closed="closeReason"
		>
			<el-form :model="reasonForm" ref="reasonForm" label-width="100px">
        <el-form-item label="Reason:" prop="reason" :rules="[{ required: true, message: 'Please input' }]">
          <el-input
            type="textarea"
            clearable
            v-model="reasonForm.reason"
            :rows="5"
            maxlength="255"
            placeholder="Please input"
          />
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="closeReason()">Cancel</el-button>
				<el-button type="primary" :loading="saveLoading" size="small" @click="beforeConfirm">Confirm</el-button>
			</span>
		</el-dialog>
  </div>
</template>
<script>
// import 'dhtmlx-gantt/codebase/dhtmlxgantt.css';
import './dhtmlxgantt/dhtmlxgantt.css';
import gantt from 'dhtmlx-gantt';
import moment from 'moment';
import axios from 'axios'
export default {
  name: 'milestoneMaintenance',
  props: {
    id: {
      type: Number,
      default: null,
    },
    allData: {
      type: Object,
      default: {},
    }
  },
  watch: {
    ganttData(newValue, oldValue) {
      if(newValue && newValue.length > 0) {
        this.drawGantt();
      }
    },
    allData(newValue, oldValue) {
      if(newValue.projectStatus === 5) {
        this.canEdit = false;
      }
    },
  },
  data() {
    return {
      milestoneForm: {},
      riskLevel: [],
      leaderList: [],
      leaderLastList: [],
      milestoneStatus: [],
      tableData: [],
      yesOrNo: [
        { labelKey: 1, labelValue: 'Yes' },
        { labelKey: 0, labelValue: 'No' }
      ],
      initUser: [],
      tableLoading: false,
      saveLoading: false,
      canEdit: true,
      ganttData: [],
      isAdd: false,
      reasonVisible: false,
      reasonForm: {
        reason: '',
      },
      openReasonInfo: {
        type: ''
      },
      AttributeList: [
					{
						labelKey:1,
						labelValue:'Mgmt.'
					}, {
						labelKey: 2,
						labelValue:'Delivery'
					}
				],
    };
  },
  mounted() {
    this.getSelectInfo();
    // this.getMilestone();
		this.getStatus(6);
  },
  methods: {
    getStatus(type) {
      let url =`${this.$store.state.islhurl}majorProjectFlow/statusCheck?majorProjectId=${this.id}&&flowType=${type}`;
      let params = {
        islhToken : sessionStorage.getItem('islhtoken'),
      }
      this._post(url, params).then(
        res => {
          if(res.code === 200) {
            this.canEdit = false;
            if(this.isAdd) {
              this.milestoneForm['tableData'].splice(0, 1);
            }
          }
        }
      )
    },
    getSelectInfo() {
      let url = `${this.$store.state.islhurl}configMain/queryLabelList?`;
      let configKeyList = [
        // 'riskLevel',
        'milestoneStatus',
      ]
      let str = '';
      configKeyList.forEach(item => {
        str += `&configKeyList=${item}`;
      })
      url = url + str.substring(1)
      const _this = this
      this._post(url).then(
        res => {
          if (res.data && res.code === 200) {
            Object.keys(res.data).forEach(function(key) {
              _this[key] = res.data[key];
            });
          }
        }
      )
    },
    getMilestone(type) {
      let url = `${this.$store.state.islhurl}majorProjectMilestone/getMilestoneList/9999/1`
      let params = {
        majorProjectId: this.id,
        islhToken: sessionStorage.getItem('islhtoken'),
        eosToken: sessionStorage.getItem('eostoken'),
      }
      this.tableLoading = true;
      this._post(url, params).then(
        res =>{
          this.tableLoading = false;
          if(res.code === 200) {
            let tableData = [];
            res.data.forEach((item, index)=>{
              tableData.push({
                ...item,
                predecessorTaskNumber: item.predecessorTaskNumber === null ? undefined : item.predecessorTaskNumber,
                taskLeader: item.taskLeader ? item.taskLeader.split(',') : [],
                startTime: item.startTime ? moment(item.startTime).format('YYYY-MM-DD') : '',
                endTime: item.endTime ? moment(item.endTime).format('YYYY-MM-DD') : '',
              })
            })
            const allLeaders = tableData.flatMap(entry => entry.taskLeader);
            this.initUser = [...new Set(allLeaders)];
            if(tableData.length === 1 && this.canEdit) {
              this.isAdd = true;
              tableData.splice(0, 0, { taskLeader: []});
            }
            this.milestoneForm = { tableData };
            this.ganttData = tableData;
            this.$nextTick(() => {
              this.$refs.milestoneForm.clearValidate();
            });
            // if(type === 'delete') {
            //   this.changeProgressRatio();
            // }
            if (this.initUser && this.initUser.length > 0) {
              let obj = {
                empCodeList: this.initUser
              }
              let url =`${this.$store.state.islhurl}user/batch-get`;
              this._post(url, obj).then(
                res => {  
                  if(res.code === 200 && res.data) {
                    this.leaderList = res.data
                    this.leaderLastList = res.data
                  }
                }
              )
            }
          } else {
            this.$message({
              type:'error',
              message: res
            });
          }
        }
      ).catch(() => {
        this.tableLoading = false;
      });
    },
    filterUser(query) {
      if (query !== '') {
        // 清除之前的定时器
        if (this.timeout) {
          clearTimeout(this.timeout)
        }
        // 防抖处理，300ms后执行
        this.timeout = setTimeout(() => {
          this.fetchUserOptions(query)
        }, 200)
      } else {
        this.leaderList = [];
      }
    },
    fetchUserOptions(query) {
      let url =`${this.$store.state.islhurl}user/select-option?keyword=${query}`;
      this._get(url).then().then(res => {
        if(res.code === 200 && res.data) {
          this.leaderList = res.data;
        } else {
          this.leaderList = [];
        }
      }).catch(error => {
        this.leaderList = [];
        console.error('搜索失败:', error)
      })
    },
    addRow(index) {
			this.milestoneForm['tableData'].splice(index + 1, 0, { taskLeader: []});
      this.$nextTick(() => {
        this.$refs.milestoneForm.clearValidate();
      });
    },
    beforeDeleteRow(row, index) {
      if (row.id) {
        const _this = this;
        this.judgeReason([row], 'delete')
          .then(response => {
            const { data } = response;
            if(data && data.code === 200 && data.data && data.data.flag === false) {
              _this.$confirm("Are you sure to delete", "Warning", {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                type: 'warning'
              }).then(() => {
                _this.openReasonInfo = { type: '', row, index };
                _this.deleteRow();
              }).catch(() => {
              });
            } else {
              _this.openReasonInfo = { type: 'delete', row, index };
              _this.reasonVisible = true;
            }
          })
          .catch(error => {
          });
      } else {
        this.milestoneForm['tableData'].splice(index, 1);
        this.changeProgressRatio();
        this.changeDays();
        this.changStartTime();
        this.changEndTime();
      }
    },
    deleteRow() {
      const { row, index } = this.openReasonInfo;
      let url = `${this.$store.state.islhurl}majorProjectMilestone/delete`
      let params = {
        id: row.id,
        islhToken: sessionStorage.getItem('islhtoken'),
        eosToken: sessionStorage.getItem('eostoken'),
        reasonParam: this.reasonForm.reason,
      }
      this.saveLoading = true;
      this._post(url, params).then(
        res =>{
          this.saveLoading = false;
          if(res.code === 200) {
            this.milestoneForm['tableData'].splice(index, 1);
            this.$Message.success('Delete Successful' );
            this.getMilestone('delete');
            this.getStatus(6);
            this.closeReason();
          } else {
            this.$message({
              type:'error',
              message: res
            });
          }
        }
      ).catch(err => {
        _this.saveLoading = false;
      })
    },
    changeDays() {
      let allDays = 0;
      const tableData = this.milestoneForm.tableData;
      tableData.forEach((item, index) => {
        if(tableData.length > 1 && index < tableData.length - 1) {
          allDays += (item.estimatedWorkload || 0);
        }
      })      
      this.changeLHA();
      const newLastData = tableData[tableData.length - 1];
      newLastData.estimatedWorkload = allDays.toFixed(2);
      this.$set(this.milestoneForm.tableData, tableData.length - 1, newLastData);
    },

    changeLHA() {
      let allMgmt = 0;
      let allDelivery = 0;
      const tableData = this.milestoneForm.tableData;
      tableData.forEach((item, index) => {
        if (tableData.length > 1 && index < tableData.length - 1) {
          if (item.workAttribute == 1) {
            allMgmt+=(item.estimatedWorkload||0)
          }
          if (item.workAttribute == 2) {
            allDelivery += (item.estimatedWorkload || 0)
          }
        }
      })
      const newLastData = tableData[tableData.length - 1];
      newLastData.allMgmt = allMgmt.toFixed(2);
      newLastData.allDelivery = allDelivery.toFixed(2);
      this.$set(this.milestoneForm.tableData, tableData.length - 1, newLastData)
      this.$emit('setMgmt', allMgmt.toFixed(2));
      this.$emit('setDelivery', allDelivery.toFixed(2));
    },

    changeProgressRatio() {
      let allProgress = 0;
      const tableData = this.milestoneForm.tableData;
      tableData.forEach((item, index) => {
        if(tableData.length > 1 && index < tableData.length - 1) {
          allProgress += 1 / (tableData.length - 1) * (item.progressRatio || 0);
        }
      })
      const newLastData = tableData[tableData.length - 1];
      newLastData.progressRatio = allProgress.toFixed(2);
      this.$set(this.milestoneForm.tableData, tableData.length - 1, newLastData)
    },
    disabledStartDate(time) {
      if(!this.allData.projectPlanStartDate) {
        return true;
      } else {
        const referenceTime = new Date(this.allData.projectPlanStartDate).setHours(0, 0, 0, 0);
        const currentTime = time.getTime();
        return currentTime < referenceTime;
      }
    },
    disabledEndDate(time) {
      if(!this.allData.projectPlanEndDate) {
        return true;
      } else {
         const referenceTime = new Date(this.allData.projectPlanEndDate).setHours(23, 59, 59, 999);
          const currentTime = time.getTime();
          return currentTime > referenceTime;
      }
    },
    changStartTime() {
      const tableData = this.milestoneForm.tableData;
      const tableNewData = this.milestoneForm.tableData.slice(0, -1);
      const validItems = tableNewData.filter(item => item.startTime !== null);
      if (validItems.length > 0) {
        const earliestItem = validItems.reduce((earliest, current) => 
          new Date(current.startTime) < new Date(earliest.startTime) ? current : earliest
        );
        const newLastData = tableData[tableData.length - 1];
        newLastData.startTime = earliestItem.startTime;
        this.$set(this.milestoneForm.tableData, tableData.length - 1, newLastData);
      } else {
        const newLastData = tableData[tableData.length - 1];
        newLastData.startTime = '';
        this.$set(this.milestoneForm.tableData, tableData.length - 1, newLastData);
      }
    },
    changEndTime() {
      const tableData = this.milestoneForm.tableData;
      const tableNewData = this.milestoneForm.tableData.slice(0, -1);
      const validItems = tableNewData.filter(item => item.endTime !== null);
      if (validItems.length > 0) {
        const latestItem = validItems.reduce((latest, current) => 
          new Date(current.endTime) > new Date(latest.endTime) ? current : latest
        );
        const newLastData = tableData[tableData.length - 1];
        newLastData.endTime = latestItem.endTime;
        this.$set(this.milestoneForm.tableData, tableData.length - 1, newLastData);
      } else {
        const newLastData = tableData[tableData.length - 1];
        newLastData.endTime = '';
        this.$set(this.milestoneForm.tableData, tableData.length - 1, newLastData);
      }
    },
    beforeConfirm() {
      const { type } = this.openReasonInfo;
      this.$refs.reasonForm.validate((valid) => {
        if (valid) {
          if(type === 'delete') {
            this.deleteRow();
          } else {
            this.saveRefreshGant();
          }
        }
      });
    },
    async judgeReason(list, operationType) {
      try {
        let url = `${this.$store.state.islhurl}majorProjectMilestone/judgmentPopUp`
        let params = [];
        list.forEach((item, index) => {
          params.push({
            ...item,
            majorProjectId: this.id,
            taskLeader: item.taskLeader.join(','),
            islhToken: sessionStorage.getItem('islhtoken'),
            eosToken: sessionStorage.getItem('eostoken'),
            startTime: item.startTime ? moment(item.startTime).format('YYYY-MM-DD HH:mm:ss') : '',
            endTime: item.endTime ? moment(item.endTime).format('YYYY-MM-DD HH:mm:ss') : '',
            serialNumber: item.serialNumber === 999 ? 999 : index + 1,
          })
        })
        let fd = new FormData();
        fd.append('operationType', operationType)
        fd.append('allListParam', new Blob([JSON.stringify(params)], {type: 'application/json'}))
        const response = await axios.post(url, fd);
        return response;
      } catch (error) {
        console.error('调用API时出错:', error);
        throw error; 
      }
    },
    saveBeforeRefreshGant() {
      this.$refs.milestoneForm.validate((valid) => {
        if (valid) {
          let timeJudge = 0;
          this.milestoneForm.tableData.forEach((item, index) => {
            const startTime = moment(item.startTime, 'YYYY-MM-DD HH:mm:ss').hours(0).minutes(0).seconds(0);
						const endTime = moment(item.endTime, 'YYYY-MM-DD HH:mm:ss').hours(0).minutes(0).seconds(0);
						if (item.startTime && item.endTime && endTime.isBefore(startTime)) {
							timeJudge = 1;
						}
          })
          if(timeJudge == 1) {
            this.$message.error('Project Milestone Planning End Date cannot be earlier than Start Date!' );
            return false;
          }
          const _this = this;
          this.judgeReason(this.milestoneForm.tableData, 'save')
            .then(response => {
              const { data } = response;
              if(data && data.code === 200 && data.data && data.data.flag === false) {
                _this.saveRefreshGant();
              } else {
                _this.reasonVisible = true;
                _this.openReasonInfo = { type: 'save', row: {}, index: '' };
              }
            })
            .catch(error => {
            });
        } else {
          this.$message.error('Please check the red error message on the page content~')
        }
      });
    },
    closeReason() {
      this.reasonVisible = false;
      this.openReasonInfo = { type: '', row: {}, index: '' };
      this.reasonForm = {
        reason: '',
      };
      this.$nextTick(() => {
        this.$refs.reasonForm.clearValidate();
      });
    },
    saveRefreshGant() {
      let url = `${this.$store.state.islhurl}majorProjectMilestone/AllSaveOrOther`
      let params = [];
      let allProgress = 0;
      let dataLength = this.milestoneForm.tableData.length;
      this.milestoneForm.tableData.forEach((item, index) => {
        params.push({
          ...item,
          majorProjectId: this.id,
          taskLeader: item.taskLeader.join(','),
          islhToken: sessionStorage.getItem('islhtoken'),
          eosToken: sessionStorage.getItem('eostoken'),
          startTime: item.startTime ? moment(item.startTime).format('YYYY-MM-DD HH:mm:ss') : '',
          endTime: item.endTime ? moment(item.endTime).format('YYYY-MM-DD HH:mm:ss') : '',
          serialNumber: item.serialNumber === 999 ? 999 : index + 1,
        })
        // if(this.milestoneForm.tableData.length > 1 && index > 0) {
        //   allProgress += 1 / (dataLength - 1) * (item.progressRatio || 0);
        // }
      })
      // params[0].progressRatio = allProgress.toFixed(2);
      this.saveLoading = true;
      const _this = this;
      let fd = new FormData();
      fd.append('reasonParam', this.reasonForm.reason)
      fd.append('allListParam', new Blob([JSON.stringify(params)], {type: 'application/json'}))
      this._post(url, fd).then(
        res =>{
          this.saveLoading = false;
          if(res.code === 200) {
            this.$Message.success('Save Successful!' );
            this.getMilestone();
            this.getStatus(6);
            this.closeReason();
            // this.canEdit = false;
          } else {
            this.$message({
              type:'error',
              message: res
            });
          }
        }
      ).catch(err => {
        _this.saveLoading = false;
      })
        
    },
    drawGantt() {
      let data = []
      this.milestoneForm.tableData.forEach((item, index) => {
        if(item.startTime && item.endTime) {
          data.push({
            id: index + 1,
            start_date: moment(item.startTime).format('DD-MM-YYYY'),
            end_date: moment(item.endTime).format('DD-MM-YYYY'),
            text: item.missionCritical,
            progress: item.progressRatio ? item.progressRatio * 0.01 : 0,
          })
        }
      })
      // 初始化 Gantt 图
      gantt.init("gantt_here");
      gantt.config.readonly = true;  // 只读模式
      // gantt.config.show_grid = false  // 左侧列表展示
      gantt.config.grid_width = 300;
      gantt.config.open_split_tasks = true;
      gantt.config.fit_tasks = true  // 甘特图自动扩展时间尺度以适应所有显示的任务
      gantt.config.columns = [
        {
          name: 'text',
          label: 'Key Task',
          tree: true,
          width: '*',
          align: 'left',
          template: function (obj) { return `<span class="gantt-name-box" title="${obj.text}">${obj.text}</span>` }
        }
      ];
      gantt.plugins({ tooltip: false });
      gantt.templates.task_text = function(start, end, task) {
        if(task.progress) {
          return "<span style='color:#6d6b6b;'>" + task.progress * 100 + "%</span>";
        } else {
          return "<span style='color:#6d6b6b;'>0%</span>";
        }
      };
      gantt.clearAll();
      gantt.parse({data});  // 加载新的数据
    },
    goFlowQuery() {
      let params = {
        flowName: this.allData.projectName,
        flowType: 6,
      }
      this.$router.push({ name: 'flowQuery', params })
    }
  }
}
</script>
<style lang="less" scoped>
.milestone-table {
	/deep/.cell {
    padding: 10px 8px 0 8px!important;
  }
  /deep/.el-table__header-wrapper .cell {
    padding: 8px!important;
  }
  /deep/.el-form-item {
    margin-bottom: 10px;
  }
  /deep/.el-form-item__error {
    padding-top: 0;
    top: 90%;
  }
  /deep/.el-form-item__content .el-input__suffix {
    left: initial;
    right: 5px;
  }
  /deep/.el-select {
    width: 100%;
  }
  /deep/.el-table__cell {
    padding: 0;
    .el-input__inner {
      padding: 0 8px;
    }
    .el-input-number {
      width: 100%;
      .el-input__inner {
        text-align: left;
      }
    }
    .el-date-editor .el-input__inner {
      padding-left: 30px;
    }
    .hasStar span {
      color: #F56C6C;
      padding-left: 1px;
    }
    .el-input__icon {
      line-height: inherit;
    }
  }
  /deep/tbody tr:last-child {
    background-color: #cfe4f9;
    .el-input.is-disabled .el-input__inner,
    .el-input__inner {
      font-weight: bold;
    }
  }
}
.milestoneMaintenance {
  /deep/.el-dialog__body {
    padding-bottom: 0
  }
}
</style>


// WEBPACK FOOTER //
// src/view/major/milestoneMaintenance/index.vue